import tableListAccountPlatform from 'View/report/const/tableListAccountPlatform';
import tableListHost from 'View/report/const/tableListHost';
import tableListBrand from 'View/report/const/tableListBrand';
import tableListSession from 'View/report/const/tableListSession';

const getTableList = ({ selectedTab, targetMonth, t }) => {
  switch (selectedTab) {
    case 'brand':
      return tableListBrand({ targetMonth, t });

    case 'host':
      return tableListHost({ targetMonth, t });

    case 'session':
      return tableListSession({ t });

    case 'accountPlatform':
      return tableListAccountPlatform({ t });

    default:
      return tableListBrand({ targetMonth, t });
  }
};

export default getTableList;
